/* Amenaa size engine: body estimate from height + weight (+ shape), then a check
   against the product's own chart. All widths in cm, full round (circumference). */
var AmenaaSize = (function () {
  "use strict";
  // Room the garment needs over the body (garment round minus body round), cm.
  // min = still wearable, ideal = the intended fit.
  var EASE = {
    woven: { min: 6, ideal: 12 }, knit: { min: -2, ideal: 8 }, stretch: { min: 0, ideal: 8 },
    open: { min: -10, ideal: 0 }, coat: { min: 10, ideal: 18 }
  };
  var BOTTOM_EASE = { woven: { min: 4, ideal: 10 }, denim: { min: 0, ideal: 4 }, knit: { min: 0, ideal: 6 }, stretch: { min: 2, ideal: 8 } };
  var PREF = { snug: -4, regular: 0, relaxed: 8 }; // shifts the ideal room
  // waist = where a pull-on band sits, not the narrowest point. 0.875 x hips is calibrated
  // on Amenaa's own gabardine kilo notes (36 = 60 kg ... 44 = 85 kg).
  var SHAPE = {                                    // bust and waist from hips
    pear: { bust: -12, waist: 0.82 }, even: { bust: -6, waist: 0.875 }, top: { bust: 0, waist: 0.95 }
  };

  // Hip round from height + weight: body as a cylinder, width grows with sqrt(weight / height).
  // 165 cm / 65 kg -> 100 cm, 155 cm / 80 kg -> 114 cm.
  function estimateBody(h, w, shape, known) {
    var s = SHAPE[shape] || SHAPE.even, hip = 159 * Math.sqrt(w / h);
    var b = { height: h, weight: w, hip: hip, bust: hip + s.bust, waist: hip * s.waist, estimated: true };
    b.waistNatural = b.waist - 0.075 * hip;
    if (known && known.hip) { b.hip = known.hip; b.estimated = false; }
    if (known && known.bust) { b.bust = known.bust; b.estimated = false; }
    if (known && known.waist) { b.waist = known.waist; b.waistNatural = known.waist; }
    if (known && known.hip && !known.waist) b.waist = known.hip * s.waist;
    b.adjKg = w * 165 / h; // weight a 165 cm woman of the same width would have
    return b;
  }

  function round2(unit, v) { return unit === "flat" ? v * 2 : v; }

  // Room in cm per measured spot, for one size of one piece.
  function rooms(piece, sz, body, pref) {
    var out = [], top = piece.part !== "bottom", k = piece.kind, e;
    if (sz.bust != null) {
      e = EASE[k] || EASE.woven;
      out.push({ spot: "bust", room: round2(piece.unit, sz.bust) - body.bust, min: e.min, want: e.ideal + pref, open: k === "open" });
    }
    if (sz.hip != null) {
      e = top ? (EASE[k] || EASE.woven) : (BOTTOM_EASE[k] || BOTTOM_EASE.woven);
      out.push({ spot: "hips", room: round2(piece.unit, sz.hip) - body.hip, min: e.min, want: e.ideal + pref });
    }
    if (sz.waist) {
      // tailored trousers sit at the natural waist (narrower), pull-on pants sit lower
      var bw = piece.rise === "natural" ? body.waistNatural : body.waist;
      // elastic band: wearable up to 2 cm short of full stretch, comfortable at 75% of its stretch
      var relaxed = round2(piece.unit, sz.waist[0]), stretched = round2(piece.unit, sz.waist[1]);
      var comfy = relaxed + 0.75 * (stretched - relaxed);
      out.push({ spot: "waist", room: stretched - bw, min: 2, want: stretched - comfy + Math.max(pref, 0) });
    }
    if (sz.maxKg) out.push({ spot: "weight", room: sz.maxKg - body.adjKg, min: -2, want: 0, kg: true });
    return out;
  }

  // Where the hem lands on this customer.
  function lengthNote(piece, len, h) {
    if (!len) return null;
    var floor;
    if (piece.lenFrom === "waist") floor = 0.62 * h - len;      // natural waist height
    else floor = 0.818 * h - len;                                // shoulder height
    var ankle = 0.045 * h, knee = 0.285 * h, hipLine = 0.50 * h, thigh = 0.40 * h;
    var cm = Math.round(Math.abs(floor));
    if (floor <= -3) return { level: "long", text: "Long on you: about " + cm + " cm extra on the floor. Hem it or wear heels." };
    if (floor <= ankle + 2) return { level: "ok", text: "Full length on you, reaching the ankle or floor." };
    if (floor <= knee - 8) return { level: "ok", text: "Ends about " + cm + " cm above the floor (mid-calf)." };
    if (floor <= knee + 5) return { level: "ok", text: "Ends around the knee." };
    if (floor <= thigh) return { level: "ok", text: "Ends at mid-thigh, covers the hips." };
    if (floor <= hipLine - 4) return { level: "ok", text: "Ends just below the hips." };
    return { level: "short", text: "Ends above the hips on you." };
  }

  function fits(list, key) { for (var i = 0; i < list.length; i++) if (list[i].room < list[i][key]) return false; return true; }

  // Main call. sizeNames = the product's real variant names (to match "Xl" vs "XL").
  function recommend(product, body, prefKey) {
    var pref = PREF[prefKey] || 0, names = Object.keys(product.pieces[0].sizes), res = [];
    names.forEach(function (n) {
      var all = [], lens = [];
      product.pieces.forEach(function (p) {
        var sz = p.sizes[n]; if (!sz) return;
        rooms(p, sz, body, pref).forEach(function (r) { r.piece = p.label || ""; all.push(r); });
        var L = lengthNote(p, sz.length || p.length, body.height);
        if (L) { L.piece = p.label || ""; lens.push(L); }
      });
      res.push({ size: n, rooms: all, length: lens, ideal: fits(all, "want"), wearable: fits(all, "min") });
    });
    var pick = null, alt = null, status;
    for (var i = 0; i < res.length; i++) if (res[i].ideal) { pick = i; break; }
    if (pick !== null) {
      status = "good";
      // a size below that is still wearable = the fitted option
      if (pick > 0 && res[pick - 1].wearable) alt = { i: pick - 1, why: "for a more fitted look" };
      else if (pick < res.length - 1) {
        var tight = res[pick].rooms.some(function (r) { return !r.kg && r.room - r.want < 3; });
        if (tight) alt = { i: pick + 1, why: "if you like it looser" };
      }
    } else {
      for (i = 0; i < res.length; i++) if (res[i].wearable) { pick = i; break; }
      if (pick !== null) { status = "close"; if (pick < res.length - 1) alt = { i: pick + 1, why: "for more room" }; }
      else { pick = res.length - 1; status = "tight"; }
    }
    return { status: status, size: res[pick].size, detail: res[pick], alt: alt ? res[alt.i].size : null, altWhy: alt ? alt.why : "", all: res, estimated: body.estimated };
  }

  return { estimateBody: estimateBody, recommend: recommend, lengthNote: lengthNote };
})();
if (typeof module !== "undefined") module.exports = AmenaaSize;
